import React from 'react'
import Styles from "./loginSignUp.module.css"

function ImageChange() {


  return (
      <div className={Styles.imageChangeDiv}>
          <div className={Styles.imageChanger}>
          </div>
      </div>
  )
}

export default ImageChange